<template>
  <div class="add-to-cart form-group col-12">
    <button
      class="primary-btn"
      :disabled="!totalProductPrice"
    >
      {{ addToCartText }}
      <strong v-if="totalProductPrice">{{ totalProductPrice }}</strong>
    </button>
    <!-- <small v-html="$t('delivery_time', { entity: entityText, hours: deliveryTime })"></small> -->
    <small class="text-center">{{ $t("Carefully check data") }}</small>

    <DiscountBanner />

  </div>
</template>
<script>
import DiscountBanner from './DiscountBanner.vue'
import useProduct from '../useProduct'
import { deliveryTime } from '../../../../config'

export default {
  components: {
    DiscountBanner,
  },
  props: {
    addToCart: {
      type: String,
    },
    entity: {
      type: String,
    },
  },
  setup() {
    const { totalProductPrice } = useProduct()

    return {
      totalProductPrice,
      deliveryTime,
    }
  },
  computed: {
    entityText() {
      if (this.entity) {
        return this.entity
      }

      return this.$t('Table')
    },
    addToCartText() {
      if (this.addToCart) {
        return this.addToCart
      }

      return this.$t('Add table to cart')
    },
  },
}
</script>
